import React, {Component} from 'react';
import axios from 'axios';
import {Container, Accordion, Icon, Grid} from 'semantic-ui-react';

export default class RefreshTokens extends Component {

    state = {access_tokens: [], activeIndex: 0};

    handleClick = (e, titleProps) => {
        const { index } = titleProps;
        const { activeIndex } = this.state;
        const newIndex = activeIndex === index ? -1 : index;

        this.setState({ activeIndex: newIndex })
    };

    componentDidMount() {
        axios.get("/api/refreshTokens").then(res => {
            if (res.status === 200 && res.data) {
                this.setState({access_tokens: res.data});
            }
        });
    }

    render() {

        const {access_tokens, activeIndex} = this.state;

        return (
            <Container>
                <Grid centered columns={2}>
                    <Grid.Column>
                        <Accordion styled>
                            {access_tokens.map(token => (
                                <div key={token.connector}>
                                    <Accordion.Title active={activeIndex === token.connector} index={token.connector} onClick={this.handleClick}>
                                        {activeIndex === token.connector ?
                                            <Icon className='hooli-text-blue' name='angle up'/>
                                            : <Icon className='hooli-text-blue' name='angle down'/>}
                                        {token.connector}
                                    </Accordion.Title>
                                    <Accordion.Content active={activeIndex === token.connector}>
                                        <p>
                                            <h4>ID Token</h4>
                                            <p>{token.id_token}</p>
                                        </p>
                                        <p>
                                            <h4>Refresh Token</h4>
                                            <p>{token.refresh_token}</p>
                                        </p>
                                        <p>
                                            <h4>Expires</h4>
                                            <p>{token.expires}</p>
                                        </p>
                                    </Accordion.Content>
                                </div>
                            ))}
                        </Accordion>
                    </Grid.Column>
                </Grid>
            </Container>
        )

    }

}
